module.exports = __webpack_public_path__ + "static/images/leaflet-measure/rulers_@2X.png";